export const sectionHeaderVariants = {
  onscreen: {
    transition: { staggerChildren: 0.15 }
  }
};

export const sectionHeaderChildrenVariants = {
  offscreen: {
    y: 50,
    opacity: 0
  },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
};